<template>
  <wrapper-edit
    :wrapper-width="wrapperWidth"
    class="edit"
    @back="paasPageBack()">
    <Form ref="paasForm" slot="form"
          :model="paasFormData"
          :rules="paasFormRules"
          :label-width="defaultLabelWidth">
      <Row>
        <FormItem label="定单号："  class="ivu-col-span-24" >
          <span>{{paasFormData.orderCode}}</span>
        </FormItem>
      </Row> 
      <Row>
        <FormItem label="快递名称：" prop="expressId" class="ivu-col-span-24">
          <EntitySelect v-model="paasFormData.expressId"
                         key="express"
                        :fieldConfig="expressConfig"
                        queryUrl="/eb/express/getTableData"
                        @on-change="setExpressData"  :disabled="paasFormData.status == '2'">
          </EntitySelect>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="快递单号：" prop="expressCode" class="ivu-col-span-24" >
          <Input v-model="paasFormData.expressCode" :disabled="paasFormData.status == '2'"></Input>
        </FormItem>
      </Row>
       
      <div class="edit-oper-toolbar">
        <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
        <mButton @click="paasPageBack('','/eb/order/send/list')">返回</mButton>
      </div>
    </Form>
  </wrapper-edit>
</template>

<script>
 import wrapperEdit from "@/components/paas/wrapper-edit";
   import EntitySelect from '@components/paas/refer/entitySelect';
   import metaEdit from "@/assets/js/meta-edit.js";
   import mButton from '@/components/button/m-button';
    export default {
      mixins: [ metaEdit ],
      components:{EntitySelect,wrapperEdit, mButton},
      data () {
        return {
          serviceUrl: "/eb/order/send",
          paasFormData: {
            id: "",
            name: "",
            expressId: "",
            expressName: "",
            expressCode: "",
            expressDetail: "",
            operateUid: "",
            operateName: "",
            completeTime: "",
            fkaOrderProductId:"",
            expressCom:"",
            orderCode:"",
            orderId:"",
            status:"",
            paasRepeatSubmitFlag: "",
          },
          expressConfig: {
            idField: "id",
            nameField: "name",
            idFieldChild: "id",
            nameFieldChild: "name",
            showName: "name",
            otherField:"code,expressCom@code",
          },
          paasFormRules: {
            expressId: {message: "物流名称必填", trigger: 'blur', required: true,},
            expressCode: {message: "物流单号必填", trigger: 'blur', required: true,},
          },
          currentIdFiledName:'id',
          redirectName: 'ebOrderSendList',
          nextAddName: 'ebOrderSendEdit',
          wrapperWidth:'40%'
        }
      },
      methods: {
        setExpressData(data){
          this.paasFormData.expressId = data.id;
          this.paasFormData.expressName = data.name;
          this.paasFormData.expressCom = data.expressCom;
        }
      }
    }
</script>

<style scoped>
  .edit /deep/ .body{
    height: calc(100vh - 120px);
    overflow: auto;
  }

</style>
